export default defineNuxtRouteMiddleware(async (to) => {
    const { public: config } = useRuntimeConfig();

    if (import.meta.dev || config.appStage !== 'prod') {
        return;
    }
    return navigateTo('/404');
});
